import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HmiLookupService } from '@uygulamalar/hmi-pdks/pano/pages/personel/services/hmi-lookup.service';

@Component({
  selector: 'widget-makine-durum',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="mk-kapsayici">
      <div class="mk-baslik">
        <span class="mk-ikon">⚙️</span>
        <span class="mk-baslik-metni">Makineler</span>
      </div>
      @if (makineler().length) {
        <div class="mk-liste">
          @for (m of makineler(); track m._id) {
            <div class="mk-satir" [class]="durumSinifi(m.durum)">
              <span class="mk-ad">{{ m.makineAdi }}</span>
              <span class="mk-durum">{{ durumMetni(m.durum) }}</span>
            </div>
          }
        </div>
      } @else {
        <div class="mk-boş">Makine tanımlı değil</div>
      }
    </div>
  `,
  styles: [`
    .mk-kapsayici { font-family: var(--font-sistemi); }
    .mk-baslik { display: flex; align-items: center; gap: 8px; margin-bottom: 14px; }
    .mk-ikon { font-size: 18px; }
    .mk-baslik-metni { font-size: 15px; font-weight: 600; color: var(--py-metin); }
    .mk-liste { display: flex; flex-direction: column; gap: 6px; }
    .mk-satir { display: flex; align-items: center; justify-content: space-between; padding: 9px 12px; border-radius: 8px; background: var(--py-arkaplan-kart); border: 1px solid var(--py-cekirdek-10); transition: transform .15s ease; }
    .mk-satir:hover { transform: translateX(3px); }
    .mk-ad { font-size: 13px; color: var(--py-metin); }
    .mk-durum { font-size: 11px; font-weight: 600; padding: 3px 9px; border-radius: 20px; }
    .durum-calisiyor { background: rgba(82,196,26,.15); color: #52c41a; }
    .durum-bosta { background: rgba(112,112,112,.15); color: #808080; }
    .durum-tamir, .durum-bakim { background: rgba(250,173,20,.15); color: #faad14; }
    .durum-kapanis { background: rgba(24,144,255,.15); color: #1890ff; }
    .mk-boş { font-size: 13px; color: var(--py-metin-gri); text-align: center; padding: 16px 0; }
  `]
})
export class WidgetMakineDurumComponent implements OnInit {
  private lookup = inject(HmiLookupService);
  makineler = signal<any[]>([]);

  ngOnInit(): void {
    this.lookup.makineleriYukle().then((liste) => this.makineler.set(liste));
  }

  durumKod(d: string | undefined): string {
    switch (d) {
      case 'calisiyor': return 'calisiyor';
      case 'bakim': return 'bakim';
      case 'tamir': return 'tamir';
      case 'kapanis': return 'kapanis';
      default: return 'bosta';
    }
  }

  durumSinifi(d: string | undefined): string {
    return `mk-satir durum-${this.durumKod(d)}`;
  }

  durumMetni(d: string | undefined): string {
    switch (this.durumKod(d)) {
      case 'calisiyor': return 'Çalışıyor';
      case 'bakim': return 'Bakımda';
      case 'tamir': return 'Tamirde';
      case 'kapanis': return 'Kapanış';
      default: return 'Bosta';
    }
  }
}
